import { SVGProps } from 'react';

const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={64} fill="none" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M26.868 9.676a1 1 0 0 1 1.225.707l1.641 6.127a1 1 0 1 1-1.932.517L26.161 10.9a1 1 0 0 1 .707-1.224ZM34.121 10.473a1 1 0 0 1 .767 1.189l-.885 4.101a1 1 0 0 1-1.955-.422l.884-4.101a1 1 0 0 1 1.189-.767ZM20.95 14.027a1 1 0 0 1 1.414 0l3.046 3.048a1 1 0 1 1-1.414 1.414l-3.047-3.048a1 1 0 0 1 0-1.414ZM28.77 21.764a3 3 0 0 1 3.308-1.643l.141.029a3 3 0 0 1 2.393 3.119l-.396 6.597 6.748-1.809a3 3 0 0 1 3.767 2.652l1.075 13.093a3 3 0 0 1-2.213 3.143l-12.804 3.43a3 3 0 0 1-3.674-2.12l-3.671-13.702a3 3 0 0 1 .192-2.073l5.135-10.716Zm2.907.316a1 1 0 0 0-1.102.548L25.44 33.345a1 1 0 0 0-.065.69l3.672 13.702a1 1 0 0 0 1.224.707l12.804-3.43a1 1 0 0 0 .738-1.049l-1.076-13.092a1 1 0 0 0-1.255-.884l-9.428 2.527.562-9.367a1 1 0 0 0-.798-1.04l-.141-.029ZM18.413 35.693a1 1 0 0 1 1.225.707l3.584 13.375a1 1 0 0 1-1.932.518l-3.584-13.375a1 1 0 0 1 .707-1.225Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgThumbsUp;
